import React, { PureComponent } from 'react'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'

let listener = null
let alerts = []
let locked = false

function timeout (ms = 0) {
  return new Promise(resolve => setTimeout(resolve, ms))
}

function createShortId (length = 5) {
  return Math.random().toString(36).substring(0, length)
}

class Alert extends PureComponent {
  constructor (props) {
    super(props)
    this.state = {
      currentAlert: null
    }

    listener = (alert) => {
      alert.visible = true
      alert.id = createShortId()
      alert.centeredContent = alert.centeredContent !== false

      let newAlerts = alerts.slice()
      newAlerts.push(alert)
      alerts = newAlerts

      this.showNextAlertIfAny()

      // return a function to close this alert
      return () => {
        this.removeAlert(alert)
      }
    }
  }

  getCurrentAlert (skipCount = 0) {
    if (alerts.length <= skipCount) {
      return null
    }
    return alerts[skipCount]
  }

  async removeAlert (alert) {
    const reallyRemoveAlertFromArray = () => {
      const newAlerts = alerts.slice()
      const index = newAlerts.indexOf(alert)
      if (index !== -1) {
        newAlerts.splice(index, 1)
      }
      alerts = newAlerts
    }

    if (alert !== this.state.currentAlert) {
      reallyRemoveAlertFromArray()
      return
    }

    if (locked) {
      console.log('can\'t remove dialog because change is locked. Trying again in 100ms')
      setTimeout(() => {
        this.removeAlert(alert)
      }, 100)
      return
    }

    locked = true

    alert.visible = false
    this.forceUpdate()
    await timeout(500) // includes transition time in react-awesome-modal
    reallyRemoveAlertFromArray()

    locked = false
    this.showNextAlertIfAny()
  }

  async showNextAlertIfAny () {
    if (locked) {
      console.log('can\'t show next alert because change is locked')
      return
    }

    if (alerts.length === 0) {
      this.setState({
        currentAlert: null
      })
      return
    }

    const alert = alerts[0]

    this.setState({
      currentAlert: alert
    })
  }

  render () {
    const alert = this.state.currentAlert
    if (!alert) { return null}

    const titleElement = alert.title ? <DialogTitle id="alert-dialog-title">{alert.title}</DialogTitle> : null

    let errorElement = null
    if (alert.error) {
      errorElement = <DialogContentText className="alert-dialog-error">{alert.error}</DialogContentText>
    } else if (alert.htmlError) {
      errorElement = <DialogContentText className="alert-dialog-error" dangerouslySetInnerHTML={{__html: alert.htmlError}}/>
    }

    let contentElement = null
    if (alert.message) {
      contentElement = <DialogContentText id="alert-dialog-description">{alert.message}</DialogContentText>
    } else if (alert.html) {
      contentElement = <DialogContentText dangerouslySetInnerHTML={{__html: alert.html}}/>
    }

    let key = 0
    const buttons = alert.buttons ? alert.buttons.map((button) => {
      return (
        <Button
          key={key++}
          onClick={() => {
            if (button.remove || typeof button.remove === 'undefined') {
              this.removeAlert(alert)
            }
            if (button.callback) {
              button.callback()
            }
          }}
        >
          {button.label}
        </Button>
      )
    }) : null

    const size = alert ? alert.size : ''

    return (
      <div key={alert.id}>
        <Dialog
          open={alert.visible}
          fullScreen={size === 'fullscreen'}
          fullWidth={size === 'large'}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          {titleElement}
          <DialogContent>
            {contentElement}
          </DialogContent>
          <DialogActions>
            {buttons}
          </DialogActions>
        </Dialog>
      </div>
    )
  }
}

export function showHtmlAlert(htmlMessage, title, buttons = []) {
  if (listener) {
    let copyButtons = buttons

    if (copyButtons.length === 0) {
      copyButtons.push({
        label: 'OK',
      })
    }
    return listener({html: htmlMessage, title: title, buttons: copyButtons})
  }
  return null
}

export function showAlert(message, title, buttons = []) {
  if (listener) {
    let copyButtons = buttons

    if (copyButtons.length === 0) {
      copyButtons.push({
        label: 'OK',
      })
    }
    return listener({message: message, title: title, buttons: copyButtons})
  }
  return null
}

export default Alert
